export const environment = {
  production: false,
  apiUrl: 'https://pbase.tecsolutions.com.ar:8121/api/v1',
  enableLanguageSelector: true,
  enableAppNotifications: true,
  logo: 'logotec.png',
  favicon: 'favicon-tec.ico',
};
